import type { DataResponse, LicenseResponse, LicenseStatusResponse, LicenseSuspend, LicenseUpdate } from "@/types";
import { api } from "../api";

export const licenseService = {
  /** Get license status (any platform admin) */
  getStatus: () => api.get<DataResponse<LicenseStatusResponse>>("/admin/license/status"),

  /** Get full license details (MH admin only) */
  getDetail: () => api.get<DataResponse<LicenseResponse>>("/admin/license"),

  /** Update license configuration (MH admin only) */
  update: (data: LicenseUpdate) => api.put<DataResponse<LicenseResponse>>("/admin/license", data),

  /** Suspend the platform (MH admin only) */
  suspend: (data: LicenseSuspend) => api.post<DataResponse<LicenseResponse>>("/admin/license/suspend", data),

  /** Resume the platform (MH admin only) */
  resume: () => api.post<DataResponse<LicenseResponse>>("/admin/license/resume", {}),
};
